import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFound = () => {

  return (
    <Container className="text-center mt-5">
      <Row>
        <Col>
          <h1 className="display-1">404</h1>
          <h2 className="mb-3">Page Not Found</h2>
          <p className="text-muted mb-4">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="cmn-btn">
            Go to Homepage
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
